import React, { useState } from "react";

const Pagination = (props) => {

    const [hidden, setHidden] = useState('');
//   state = {
//     hidden: "",
//   };
//   componentDidMount() {}

  const numberOfPages =() => {
    let lengthOfData = props.lengthOfData;
    let number = props.numberOfElementsPerPage;
    if (lengthOfData % number === 0) {
      return lengthOfData / number;
    } else {
      return parseInt(lengthOfData / number) + 1;
    }
  }

  const showingStringFn = () => {
    let firstElement = props.firstRowIndex + 1;
    let lastElement = props.lastRowIndex + 1;
    let number = props.numberOfElementsPerPage;

    let pageNumber = lastElement / number;
    if (lastElement % number !== 0) {
      pageNumber = parseInt(lastElement / number) + 1;
    }
    if (props.filterOn) {
      let str = "Showing filtered results (Page No. " + pageNumber + ")";
      return str;
    } else if (
      props.lengthOfData <
      props.numberOfElementsPerPage + 1
    ) {
      // console.log(this.props.lengthOfData);
      return "Showing all results";
    } else {
      return (
        "Showing " +
        firstElement +
        " to " +
        lastElement +
        " of " +
        props.lengthOfData +
        " results (Page No. " +
        pageNumber +
        ")"
      );
    }
  }

  
    let lastRowIndex = parseInt(props.lastRowIndex);
    let lengthOfData = props.lengthOfData;
    let firstRowIndex = props.firstRowIndex;
    return (
      <div className="bg-white md:px-4 py-3 flex items-center justify-between rounded-b-md border-t border-gray-200 dark:border-gray-400 sm:px-6 dark:bg-white/10 dark:text-white">
        <div className="w-full grid grid-col-1  sm:hidden">
          <div>
            <p className="text-xs text-gray-700 pt-2">
              {showingStringFn()}
            </p>
          </div>
          <div
            className={
              props.lengthOfData <= props.numberOfElementsPerPage
                ? "hidden"
                : "" + " mt-2 flex-1 flex  justify-between"
            }
          >
            <button
              id="prvButton"
              onClick={props.previousPageFn}
              className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white hover:text-gray-800 text-sm font-medium text-gray-600 hover:bg-gray-50 focus:outline-none"
            >
              Previous
            </button>

            <button
              onClick={props.nextPageFn}
              className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white hover:text-gray-800 text-sm font-medium text-gray-600 hover:bg-gray-50 focus:outline-none"
            >
              Next
            </button>
          </div>
        </div>
        <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
          <div>
            <p className="text-sm text-gray-500 dark:text-white">{showingStringFn()}</p>
          </div>
          <div
            className={
              props.lengthOfData <= props.numberOfElementsPerPage
                ? "hidden"
                : ""
            }
          >
            <nav
              className="relative inline-flex shadow-sm -space-x-px"
              aria-label="Pagination"
            >
              <button
                name="previous"
                onClick={props.previousPageFn}
                id="previous"
                className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white hover:text-blue-600 text-sm font-medium text-blue-500 hover:bg-blue-50 focus:outline-none hover:dark:bg-white/20 dark:bg-white/5 dark:text-white"
              >
                <span className="sr-only">Previous</span>
                {/* Heroicon name: chevron-left */}
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              <button
                onClick={props.firstPageFn}
                className={
                  "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-" +
                  (firstRowIndex === 0 ? "blue-100" : "white") + " dark:bg-" +
                  (firstRowIndex === 0 ? "white/20" : "white/5") +
                  " hover:text-blue-700 text-sm font-medium text-blue-500 hover:bg-blue-50 focus:outline-none hover:dark:bg-white/20 dark:bg-white/5 dark:text-white"
                }
              >
                1
              </button>

              <span className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-blue-500 dark:bg-white/5 dark:text-white">
                ...
              </span>
              <button
                name="next"
                id="next"
                onClick={props.lastPageFn}
                className={
                  "relative inline-flex items-center px-4 py-2 border border-gray-300 bg-" +
                  (lastRowIndex === lengthOfData - 1 ? "blue-100" : "white") + " dark:bg-" +
                  (lastRowIndex === lengthOfData - 1 ? "white/20" : "white/5") +
                  " hover:text-blue-700 text-sm font-medium text-blue-500 hover:bg-blue-50 focus:outline-none hover:dark:bg-white/20 dark:bg-white/5 dark:text-white"
                }
              >
                {numberOfPages()}
              </button>
              <button
                onClick={props.nextPageFn}
                className="relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white hover:text-blue-700 text-sm font-medium text-blue-500 hover:bg-blue-50 focus:outline-none hover:dark:bg-white/20 dark:bg-white/5 dark:text-white"
              >
                <span className="sr-only">Next</span>
                {/* Heroicon name: chevron-right */}
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </nav>
          </div>
        </div>
      </div>
    );
  
}
export default Pagination;
